import React, {useCallback, useEffect, useState} from "react";
import "../General/General.css";
import { InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Autocomplete from '@mui/material/Autocomplete';
import {getAllJiraProjects} from '../../utilities/jiraAPI'
import keycloak from "../../Keycloak";
import DropdownPaper from "../General/DropdownPaper";

const JiraProjectSearch = ({jiraProjectId, jiraProjectName, onChangeMethod}) => {
    const style = {
        "& label.Mui-focused": {
            color: "#EC8D2B",
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: "#EC8D2B",
            },
        },
    };

    const [projectNames, setProjectNames] = useState([]);

        const jiraProjects = useCallback(() => {
            getAllJiraProjects(keycloak.token).then((projects) => {
                if (projects.length > 0) {
                    console.log(projects);
                    const projectNames = projects.map((project) => ({
                        id: project.id,
                        projectId: project.projectId,
                        name: project.name
                    }));
                    setProjectNames(projectNames);
                    console.log(projectNames);
                } else {
                    setProjectNames([]);
                    console.log("No data returned");
                }
            })
                .catch((e) => {
                })
    },[]);

    const onChangeHandler = async (event, value) => {
        console.log(value)
        if(value) {
            jiraProjectId= value.id;
            jiraProjectName= value.name;
            onChangeMethod(value.id);
        }else{
            jiraProjectId = 0;
            jiraProjectName = "";
            onChangeMethod(0);
        }
    }
    useEffect(() => {
        jiraProjects();
    }, [jiraProjects])

    return (
        <Autocomplete
            PaperComponent={DropdownPaper}
            className="inputWidth"
            data-testid='JiraProjectAutoComplete'
            options={projectNames}
            defaultValue={jiraProjectId && jiraProjectName ? { id: jiraProjectId, name: jiraProjectName } : null}
            onChange={onChangeHandler}
            id="jiraProject"
            getOptionLabel={(option) => option.name}
            getOptionSelected={(option, value) => option.id === value.projectId}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={params?.label ?? "Jira board name"}
                    variant="outlined"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {params.InputProps.endAdornment}
                                <InputAdornment position="end" >
                                    <SearchIcon />
                                </InputAdornment>
                            </React.Fragment>
                        ),
                    }}
                    sx={style}
                />
            )}
        />
    )
};
export default JiraProjectSearch;